export type PagesSort = 'newest' | 'reputation' | 'alphabetical' | 'soonest' | 'distance'

export type PagesFilters = {
  boostedOnly: boolean
  mineOnly: boolean
  includePending: boolean
  openNow: boolean
  bookableToday: boolean
  hasBooking: boolean
  categories: string[]
  sort: PagesSort
}

export const DEFAULT_PAGES_FILTERS: PagesFilters = {
  boostedOnly: false,
  mineOnly: false,
  includePending: true,
  openNow: false,
  bookableToday: false,
  hasBooking: false,
  categories: [],
  sort: 'newest',
}

const VALID_SORT: PagesSort[] = ['newest', 'reputation', 'alphabetical', 'soonest', 'distance']

export function normalizeCategory(value: string): string {
  return String(value || '').trim().toLowerCase()
}

export function parsePagesFilters(searchParams: URLSearchParams, authed: boolean): PagesFilters {
  const rawSort = (searchParams.get('sort') || '').toLowerCase()
  const sort: PagesSort = VALID_SORT.includes(rawSort as PagesSort) ? (rawSort as PagesSort) : DEFAULT_PAGES_FILTERS.sort
  const categories = (searchParams.get('cat') || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean)
    .map(normalizeCategory)
    .filter((v, i, arr) => arr.indexOf(v) === i)

  const mineOnly = authed ? searchParams.get('mine') === '1' : false
  return {
    boostedOnly: searchParams.get('boosted') === '1',
    mineOnly,
    includePending: authed ? searchParams.get('pending') !== '0' : true,
    openNow: searchParams.get('open_now') === '1',
    bookableToday: searchParams.get('bookable_today') === '1',
    hasBooking: searchParams.get('has_booking') === '1',
    categories,
    sort,
  }
}

export function writePagesFilters(searchParams: URLSearchParams, filters: PagesFilters, authed: boolean): URLSearchParams {
  const next = new URLSearchParams(searchParams)

  if (filters.boostedOnly) next.set('boosted', '1')
  else next.delete('boosted')

  if (authed && filters.mineOnly) next.set('mine', '1')
  else next.delete('mine')

  if (authed && !filters.includePending) next.set('pending', '0')
  else next.delete('pending')

  if (filters.openNow) next.set('open_now', '1')
  else next.delete('open_now')

  if (filters.bookableToday) next.set('bookable_today', '1')
  else next.delete('bookable_today')

  if (filters.hasBooking) next.set('has_booking', '1')
  else next.delete('has_booking')

  if (filters.categories.length > 0) next.set('cat', filters.categories.join(','))
  else next.delete('cat')

  if (filters.sort !== DEFAULT_PAGES_FILTERS.sort) next.set('sort', filters.sort)
  else next.delete('sort')

  return next
}
